module.exports = __webpack_public_path__ + "static/img/quick-scan-left.d166b8ff.jpg";